import { Router } from '@angular/router';
import { Component, OnInit, HostBinding } from '@angular/core';
import { MResa, MUser } from '@argalis-apps/models';
import { CartService } from '../../services/cart/cart.service';
import { CartConfigService } from '../../services/cart-config/cart-config.service';
import { AuthService } from '../../../auth/services/auth/auth.service';
@Component({
  selector: 'ags-cart',
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.scss']
})
export class CartComponent implements OnInit {
  @HostBinding('class') themeFlag: string;

  public userConnected: MUser.CUser = null;
  public reservationList: MResa.IResa[];
  public displayPopup: boolean;
  public loading: boolean;

  constructor(
    private cartService: CartService,
    private authService: AuthService,
    cartConfigService: CartConfigService,
    private router: Router
  ) {
    this.themeFlag = `${this.themeFlag || ''} ${cartConfigService.themingClassName}`;
    this.userConnected = this.authService.userConnected;
    this.authService.userChange.subscribe((user: MUser.CUser) => {
      if (user && !user.login) this.userConnected = null;
      else this.userConnected = Object.assign({}, user);
    });
  }

  async ngOnInit() {
    this.loading = true;
    this.reservationList = this.cartService.getCart();
    this.cartService.resaListObservable().subscribe(
      (list: MResa.IResa[]) => {
        this.loading = false;
        this.reservationList = list;
        for (const resa of this.reservationList) {
          if (resa.nb_places <= 0) {
            resa.nb_places = 0;
          }
        }
      },
      () => {
        this.loading = false;
      }
    );
    // à la première initialisation de l'app, ne passe pas par cette condition if
    if (this.reservationList && this.cartService.constructorFinished) {
      // à partir de la deuxième visite sur la page /cart, on passe par ce bloc et le panier est déjà récupéré par getCart
      this.loading = false;
    }
  }

  public async removeResa(idx: number) {
    await this.cartService.removeFromCart(idx);
  }

  Redirect() {
    this.router.navigate(this.authService.getRoute('signup'));
  }

  public searchFormation() {
    this.router.navigate(['catalog']);
  }
}
